'use client'

import { useCallback, useEffect, useState } from 'react'

/**
 * Whole-second countdown used for action cooldowns (e.g. resending a magic link).
 * The interval only exists while there is time left, and is (re)armed from an event
 * handler via `start` rather than from a render effect.
 */
export function useCountdown(initialSeconds = 0) {
    const [secondsLeft, setSecondsLeft] = useState(initialSeconds)
    const isRunning = secondsLeft > 0

    useEffect(() => {
        if (!isRunning) return

        const interval = setInterval(() => {
            setSecondsLeft((current) => (current <= 1 ? 0 : current - 1))
        }, 1000)

        return () => clearInterval(interval)
    }, [isRunning])

    const start = useCallback((seconds: number) => setSecondsLeft(seconds), [])

    return { secondsLeft, isRunning, start }
}
